module.exports = __webpack_public_path__ + "static/media/Menu.f069ee29.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/svgs/SocialMediaMenu/Menu.svg
// module id = 326
// module chunks = 0